import { ShareRoute } from '@/system-modules/share/v1/api/ShareRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'
import { IPublicLink } from '@/contracts/system-modules/share/IPublicLink'

/** Открытый маршрут: токен не нужен */
export class OpenLinkRoute extends ShareRoute<null, IPublicLink> {
  constructor(private readonly uuid: string) {
    super()
  }

  type(): EnumRouteType {
    return EnumRouteType.GET
  }

  url(): string {
    return '/api/system/v1/share/public/links/' + this.uuid
  }

  /** Без сервера ссылок нет */
  offline(): Promise<ApiResponse<IPublicLink>> {
    return Promise.resolve(new ApiResponse({ success: false, error: 'link_not_found' }))
  }
}
